import { SettingsRoutes } from '../../../../routes/settings-routes';
import { AFFILIATES, BILLING, USERS, COMPANY, MY_ACCOUNT } from '../constants';

export type SidebarPage = {
  path: string;
  name: string;
  id: string;
  matchPattern: RegExp;
  requiresAdminPermission: boolean;
  accessibleLiveAgent: boolean;
};

export const sidebarPages: SidebarPage[] = [
  {
    path: SettingsRoutes.myAccount.path,
    name: MY_ACCOUNT,
    id: SettingsRoutes.myAccount.path,
    matchPattern: /my-account/,
    requiresAdminPermission: false,
    accessibleLiveAgent: true,
  },
  {
    path: SettingsRoutes.company.path,
    name: COMPANY,
    id: SettingsRoutes.company.path,
    matchPattern: /company/,
    requiresAdminPermission: true,
    accessibleLiveAgent: false,
  },
  {
    path: SettingsRoutes.billing.path,
    name: BILLING,
    id: SettingsRoutes.billing.path,
    matchPattern: /billing/,
    requiresAdminPermission: true,
    accessibleLiveAgent: false,
  },
  {
    path: SettingsRoutes.users.path,
    name: USERS,
    id: SettingsRoutes.users.path,
    matchPattern: /users/,
    requiresAdminPermission: true,
    accessibleLiveAgent: false,
  },
  {
    path: SettingsRoutes.affiliates.path,
    name: AFFILIATES,
    id: SettingsRoutes.affiliates.path,
    matchPattern: /referrals/,
    requiresAdminPermission: false,
    accessibleLiveAgent: false,
  },
];
